import React from 'react'
import { Props, StyledInput } from './styled'

export const Input: React.FC<Props> = props => {
  return <StyledInput {...props} />
}
